<template lang="pug">
el-container.main(style="max-width: 100%;")
  .satellite-detail
    el-row.row(type="flex", justify="center", :gutter="20")
      el-col(:span="24")
        el-card.box-card
          .clearfix(slot="header")
            span 基本信息
          div
            el-form(label-width="160px", size="mini", label-position="left")
              el-form-item(label="Name", style="margin-bottom: 8px") {{ this.satellite.name }}
              el-form-item(label="运行状态", style="margin-bottom: 8px") {{ this.satellite.status ? this.satellite.status.label : '' }}
              el-form-item(label="COSPAR ID", style="margin-bottom: 8px") {{ this.satellite.satcat.cospar }}
              el-form-item(label="NORAD ID", style="margin-bottom: 8px") {{ this.satellite.satcat.norad }}
              el-form-item(label="发射载重(kg)", style="margin-bottom: 8px") {{ this.satellite.launch_mass }}
              el-form-item(label="发射日期", style="margin-bottom: 8px") {{ this.satellite.satcat.launch }}
              el-form-item(label="退役日期", style="margin-bottom: 8px") {{ this.satellite.decay_date }}
              el-form-item(label="发射地点", style="margin-bottom: 8px") {{ this.satellite.site ? this.satellite.site.cn_name : '' }}
              el-form-item(label="发射工具", style="margin-bottom: 8px") {{ this.satellite.launch_vehicle }}
              el-form-item(label="应用领域", style="margin-bottom: 8px") {{ this.satellite.realm ? this.satellite.realm.name : '' }}
      el-col(:span="24")
        el-card.box-card(
          style="margin-bottom: 8px;",
          :body-style="{ padding: '0px' }"
        )
          .clearfix(slot="header")
            span 运行信息
            i.el-icon-link
            i.el-icon-set-up(
              style="float: right; padding: 3px 0",
              @click="handleOrbitPrevSwitch"
            )
          template(v-if="this.satOrbitShow")
            SatTracker(:tles="tles" :key="componentKey")
          template(v-else)
            div(style="padding: 20px;")
              el-form(label-width="160px", size="mini", label-position="left")
                el-form-item(label="轨道级别", style="margin-bottom: 8px") {{ this.satellite.orbit_altitude_class.label }}
                el-form-item(label="近地点(km)", style="margin-bottom: 8px") {{ this.satellite.satcat.apogee }}
                el-form-item(label="远地点(km)", style="margin-bottom: 8px") {{ this.satellite.satcat.perigee }}
                el-form-item(label="倾角(degrees)", style="margin-bottom: 8px") {{ this.satellite.satcat.inclination }}
                el-form-item(label="周期(minutes)", style="margin-bottom: 8px") {{ this.satellite.satcat.period }}
        el-card.box-card(style="margin-bottom: 8px;")
          .clearfix(slot="header")
            span 载荷信息
          div
            el-form(label-width="160px", size="mini", label-position="left")
              el-form-item(
                v-for="(payload, idx) in satellitePayloads",
                :key="payload.id",
                :label="'载荷' + (parseInt(idx) + 1)",
                style="margin-bottom: 8px"
              ) 
                router-link(
                  :to="{ name: 'instrument-detail', params: { id: payload.id } }"
                ) {{ payload.name }}
</template>

<script>
// @ is an alias to /src
import SatTracker from "./SatelliteTrack.vue";
import { getSatellite, getSatelliteTLE } from "@/services";

export default {
  name: "satellite-detail",
  props: ["id"],
  data() {
    return {
      loading: false,
      satellite: { satcat: { cospar: 0 } },
      dataVendorEdit: false,
      dataVendorOptions: [],
      selectedDataVendor: [],
      satOrbitShow: true,
      tles: null,
      componentKey: 0,
    };
  },
  components: {
    SatTracker,
  },
  methods: {
    /**
     * Backend Service API Func Wrapper
     */
    async fetch() {
      this.loading = true;
      const res = await getSatellite({ id: this.id });
      this.satellite = res.data;
      const res2 = await getSatelliteTLE({ norad: this.satellite.satcat.norad });
      this.tles = res2.data.items[0];
      this.loading = false;
    },
    /**
     * UI Control
     */
    handleOrbitPrevSwitch() {
      this.satOrbitShow = !this.satOrbitShow;
    },
    forceRerender() {
      this.componentKey += 1;
    }
  },
  computed: {
    satellitePayloads() {
      if (!this.satellite.payloads) {
        return [];
      }
      return this.satellite.payloads.map((payload) => payload.instrument);
    }
  },
  mounted() {
    this.fetch().then(this.forceRerender)
  },
};
</script>
<style lang="stylus" scoped>
.text {
  font-size: 14px;
}

.row {
  padding-bottom: 10px;
}

.clearfix:before, .clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.satellite-detail {
  width: 100%;
  padding: 20px 20px 0;
}

.data-vendor-tag {
  margin: 2px 2px;
}

.el-button {
  float: right;
  padding: 3px 0;
}

.el-card:nth-child(2) {
  .el-card__body {
    padding: 0;
  }
}

@media only screen and (max-width: 540px) {
  .satellite-detail {
    width: 100%;
    padding: 0;
  }

  .row {
    padding-bottom: 10px;
    flex-wrap: wrap;
  }

  .el-col:nth-child(2) {
    padding-top: 10px;
  }

  .el-card__body {
    overflow: auto;
  }
}
</style>
